import { squareBrackets } from "@rezonence/sdk";

export const invalidCharacters = ["{", "}", "|", "\\", "^", "~", "`"].concat(squareBrackets);
